export default __webpack_public_path__ + "static/media/base_logo.6f1b2ba0.png";